"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;
const react_1 = __importDefault(require("react"));
const checkbox_1 = __importDefault(require("antd/lib/checkbox"));
const date_picker_1 = __importDefault(require("antd/lib/date-picker"));
const input_1 = __importDefault(require("antd/lib/input"));
const switch_1 = __importDefault(require("antd/lib/switch"));
const input_number_1 = __importDefault(require("antd/lib/input-number"));
const TextArea_1 = __importDefault(require("antd/lib/input/TextArea"));
const react_input_mask_1 = __importDefault(require("react-input-mask"));
const Dropdown_1 = require("../Dropdown");
const TimePickerInput_1 = require("../TimePickerInput");
const RadioButtonGroupInput_1 = __importDefault(require("../RadioButtonGroupInput"));
const RadioGroupInput_1 = __importDefault(require("../RadioGroupInput"));
const Info_1 = require("../Info");
const types_1 = require("./types");
const CheckboxGroup_1 = require("../CheckboxGroup");
__exportStar(require("./types"), exports);
class Input extends react_1.default.PureComponent {
  render() {
    switch (this.props.type) {
      case types_1.FormInputType.Text:
        return react_1.default.createElement(input_1.default, Object.assign({}, this.props));
      case types_1.FormInputType.Dropdown:
        return react_1.default.createElement(Dropdown_1.Dropdown, Object.assign({}, this.props));
      case types_1.FormInputType.Email:
        return react_1.default.createElement(input_1.default, Object.assign({}, this.props, {
          type: "email"
        }));
      case types_1.FormInputType.Mask:
        return react_1.default.createElement(react_input_mask_1.default, Object.assign({}, this.props));
      case types_1.FormInputType.Time:
        return react_1.default.createElement(TimePickerInput_1.TimePickerInput, Object.assign({}, this.props));
      case types_1.FormInputType.Date:
        return react_1.default.createElement(date_picker_1.default, Object.assign({}, this.props));
      case types_1.FormInputType.Radio:
        return react_1.default.createElement(RadioGroupInput_1.default, Object.assign({}, this.props));
      case types_1.FormInputType.RadioButton:
        return react_1.default.createElement(RadioButtonGroupInput_1.default, Object.assign({}, this.props));
      case types_1.FormInputType.Switch:
        return react_1.default.createElement(switch_1.default, Object.assign({}, this.props));
      case types_1.FormInputType.Info:
        return react_1.default.createElement(Info_1.Info, Object.assign({}, this.props));
      case types_1.FormInputType.TextArea:
        return react_1.default.createElement(TextArea_1.default, Object.assign({}, this.props));
      case types_1.FormInputType.Checkbox:
        return react_1.default.createElement(checkbox_1.default, Object.assign({}, this.props));
      case types_1.FormInputType.CheckboxGroup:
        return react_1.default.createElement(CheckboxGroup_1.CheckboxGroup, Object.assign({}, this.props));
      case types_1.FormInputType.InputNumber:
        return react_1.default.createElement(input_number_1.default, Object.assign({}, this.props));
      default:
        throw new Error("Invalid FormInputType provided.");
    }
  }
}
exports.Input = Input;
exports.default = Input;